const reason = {
  listReason: {
    title: "Title",
    id: "ID",
    noReasonDescription: "No PayrollReason Found",
    reasonTitle: "Reason Name",
    actions: "Actions",
    manageReasons: "Manage Reasons",
  },
  listReasonBreadcrumb: {
    reason: "Reason List",
  },
  actions: {
    edit: "Edit",
    editReasons: "Edit Reason",
  },
  placeholder: "Please Enter Reason",
};
export default reason;
